// extracted by mini-css-extract-plugin
module.exports = {"firstSection":"_2NZsy","section":"_3Lr5y"};